import { ProjectRepository } from 'core/repositories/ProjectRepository';
import { Project } from 'core/models/project';

class DummyProjectRepository implements ProjectRepository {
    async getProjects(): Promise<Project[]> {
        return [
            { id: 'tieriv', name: 'Tier IV' },
        ];
    }
}

export { DummyProjectRepository as ProjectRepository };
